import { environment } from "src/environments/environment";

export class ConsoleHelper {
    private static readonly supress = false;

    public static log(message: any, ...optionalParams: any[]): void {
        const prod = environment.current.toLowerCase() === 'production';
        if (prod || this.supress || environment.testRunner) {
            return;
        }
        console.log(message, ...optionalParams);
    }

}
